import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  StarFill,
  StarOutline,
} from "../../assets/SvgIcons";

const ReviewSectionWithProduct = ({
  reviews,
  sectionTitle,
  sectionSubTitle,
  sectionClassName,
  navBtnStyle,
  ctaBtnStyle,
}) => {
  const scrollRef = useRef(null);
  const [cardsWidthToFit, setCardsWidthToFit] = useState(300); // Default to at least 1 card

  useEffect(() => {
    const calculateFit = () => {
      const parentWidth = scrollRef.current ? scrollRef.current.clientWidth : 0;
      const cardWidth = 300;
      const fitCount = Math.floor(parentWidth / cardWidth);

      setCardsWidthToFit(
        fitCount > 0
          ? (parentWidth - 16 * (fitCount - 1)) / fitCount
          : parentWidth
      ); // Ensure at least 1 card fits
    };

    calculateFit(); // Run initially
    window.addEventListener("resize", calculateFit); // Adjust on window resize
    return () => window.removeEventListener("resize", calculateFit); // Cleanup
  }, []);

  return (
    <section className={`${sectionClassName} `}>
      <div className="max-w-[1200px] mx-auto flex flex-col justify-center items-center lg:px-2 md:px-4 sm:px-0 lg:py-16 md:py-14 sm:py-12">
        <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-4 lg:px-0 md:px-0 sm:px-4">
          {sectionTitle}
        </h2>
        <h3 className="text-[14px] mb-3 lg:px-0 md:px-0 sm:px-4">
          {sectionSubTitle}
        </h3>
        <div className="flex gap-4 items-center w-full mb-12">
          <button
            onClick={() => {
              scrollRef.current.scrollBy({
                left: -1 * (cardsWidthToFit + 16),
                behavior: "smooth",
              });
            }}
            className={"text-[#fff] "}
            style={{ ...navBtnStyle }}
          >
            {ChevronLeft}
          </button>
          <div
            ref={scrollRef}
            className="w-full flex overflow-scroll gap-4 no-scrollbar"
          >
            {reviews.map((review, index) => (
              <ReviewCard
                key={index}
                review={review}
                cardsWidthToFit={cardsWidthToFit}
              />
            ))}
          </div>
          <button
            onClick={() => {
              scrollRef.current.scrollBy({
                left: cardsWidthToFit + 16,
                behavior: "smooth",
              });
            }}
            className={"text-[#fff] "}
            style={{ ...navBtnStyle }}
          >
            {ChevronRight}
          </button>
        </div>

        <div className="mx-auto flex justify-center items-center">
          <button
            className="py-2.5 px-10 rounded-lg border border-white text-[14px]"
            style={{ ...ctaBtnStyle }}
          >
            Display all
          </button>
        </div>
      </div>
    </section>
  );
};

export default ReviewSectionWithProduct;

const ReviewCard = ({ review, cardsWidthToFit }) => {
  return (
    <div
      style={{ minWidth: cardsWidthToFit || 300 }}
      className="transition-transform duration-500 ease-in-out relative"
    >
      {/* PRODUCT IMAGE */}
      <img
        src={review?.product?.productImage || ""}
        alt=""
        width={cardsWidthToFit - 60 || 240}
        className="-rotate-90 lg:-mb-40 md:-mb-36 sm:-mb-32 mx-auto z-0 relative"
      />
      <div className="z-10 relative bg-white text-black text-[14px] rounded-lg flex flex-col justify-between gap-4 p-8  ">
        {/* RATING AND DATE */}
        <div className="flex justify-between items-center gap-2">
          {/* RATING AND DATE */}
          <div className="flex items-center gap-0.5 text-white">
            {[...Array(review?.rating)].map((_, index) => (
              <span
                key={index}
                className="lg:py-1.5 px-0.5 md:py-1 sm:py-1 bg-primary"
              >
                {StarFill}
              </span>
            ))}
            {[...Array(5 - review?.rating)].map((_, index) => (
              <span
                key={index}
                className="lg:py-1.5 px-0.5 md:py-1 sm:py-1 bg-primary"
              >
                {StarOutline}
              </span>
            ))}
          </div>
          <span className="lg:text-[16px] md:text-[14px] sm:text-[12px]">
            {review?.date}
          </span>
        </div>
        {/* PRODUCT INFO */}
        <div>
          <p className="text-[14px] font-semibold">{review?.product?.name}</p>
          <p className="text-[12px]">{review?.receivedDate}</p>
          <p className="text-[12px]">{review?.shippedFrom}</p>
        </div>
        {/* REVIEW */}
        <div className="" style={{ minHeight: 84 }}>
          <i className=" text-[16px]"> {review?.review?.slice(0, 100)}.. </i>
        </div>

        {/* REVIEWER */}
        <div className="flex gap-2 items-center">
          <div
            className="h-[48px] w-[48px] flex justify-center items-center text-[18px] bg-primarylight rounded-full"
            // style={{ backgroundColor: review?.reviewer?.color }}
          >
            <span>{review?.reviewer?.initial}</span>
          </div>

          <div>
            <p className="text-[15px]">{review?.reviewer?.name}</p>
            <p className="text-[13px]">{review?.reviewer?.location}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
